import React from "react";
import styled from "styled-components";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Container = styled.div`
    width:900px;
    height:700px;
    margin:0 auto;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:20px;
`

const LoadingIcon = styled(FontAwesomeIcon)`
    margin-right:20px;
    -webkit-animation:spin 2s linear infinite;
    -moz-animation:spin 2s linear infinite;
    animation:spin 2s linear infinite;

    @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); }
    
`
const Loader = () => <Container><LoadingIcon icon={faSpinner} size="2x"/>Loading...</Container>

export default Loader;